var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V3H22V0Z",
    transform: "translate(1 8)",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8861 0H2.11391C0.946431 0 0 0.989451 0 2.21V12.79C0 14.0105 0.946431 15 2.11391 15H19.8861C21.0536 15 22 14.0105 22 12.79V2.21C22 0.989451 21.0536 0 19.8861 0Z",
    transform: "translate(1 5)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/Payment_Icon.a4d8c087e68917262a830321d34f294a.svg";
export { ForwardRef as ReactComponent };